import React from 'react';

import { Link } from 'react-router-dom';

import { ApplicationRoute } from 'routes/routes.enums';
import { HFS_PRIVACY_POLICY_URL } from 'constants/constants';
import Button from 'components/common/Button/Button';

import styles from './Footer.module.scss';

const Footer = () => {
  const handleProvideFeedback = async () => {
    const decodedUrl = decodeURIComponent(process.env.REACT_APP_GOOGLE_FEEDBACK_LINK || '');

    window.open(decodedUrl, '_blank', 'noreferrer');
  };

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        <div className={styles.copyRightWrapper}>
          <div className={styles.footerCopyright}>
            Copyright © {new Date().getFullYear()} HFS Financial. All Rights Reserved.
          </div>
          <a
            href={HFS_PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerPolicyLink}
          >
            | Privacy Policy
          </a>
          <Link to={ApplicationRoute.TermsOfUse} className={styles.footerPolicyLink}>
            | Terms of Use
          </Link>
        </div>
        <div className={styles.feedbackWrapper}>
          <Button className={styles.frameButton} onClick={handleProvideFeedback} variant="link">
            Provide Feedback
          </Button>
          <div className={styles.footerNmls}>NMLS ID # 1680766</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
